import { luminance, rgba } from "../utils";

const colors = {
  ice: "#f7fcfd",
  darkerIce: "#f6f7fa",
  darkerIceAlpha90: rgba("#f6f7fa", 0.9),
  darkerIceAlpha80: rgba("#f6f7fa", 0.8),
  iceAlpha40: rgba("#f7fcfd", 0.4),
  iceAlpha60: rgba("#f7fcfd", 0.6),
  iceAlpha75: rgba("#f7fcfd", 0.75),
  chalk: "#8fa9af",
  black: "#000000",
  blackAlpha12: rgba("#000000", 0.12),
  blackAlpha15: rgba("#000000", 0.15),
  blackAlpha20: rgba("#000000", 0.2),
  blackAlpha24: rgba("#000000", 0.24),
  chalkAlpha10: rgba("#8fa9af", 0.1),
  chalkAlpha20: rgba("#8fa9af", 0.2),
  chalkAlpha40: rgba("#8fa9af", 0.4),
  chalkAlpha60: rgba("#8fa9af", 0.6),
  chalkAlpha80: rgba("#8fa9af", 0.8),
  discord: "#5865f2",
  faceit: "#ff935d",
  navy900: "#0B1116",
  navy600: "#131d25",
  navy500: "#16232c",
  navy400: "#1A2933",
  navy300: "#1e2e3a",
  navy200: "#213442",
  navy100: "#253A49",
  navy50: "#2F4656",
  navy: "#253a49",
  navyAlpha90: rgba("#253a49", 0.9),
  navyAlpha70: rgba("#253a49", 0.7),
  navyAlpha50: rgba("#253a49", 0.5),
  navyAlpha20: rgba("#253a49", 0.2),
  darkerNavy: luminance("#253a49", -0.1),
  midnight: "#0c1318",
  midnightAlpha30: rgba("#0c1318", 0.3),
  midnightAlpha40: rgba("#0c1318", 0.4),
  midnightAlpha50: rgba("#0c1318", 0.5),
  midnightAlpha60: rgba("#0c1318", 0.6),
  midnightAlpha70: rgba("#0c1318", 0.7),
  midnightAlpha80: rgba("#0c1318", 0.8),
  midnightAlpha90: rgba("#0c1318", 0.9),
  midnightBlue: "#1D2E3A",
  mythic: rgba("#C7DAF6", 1),
  mythicAlpha10: rgba("#C7DAF6", 0.1),
  mythicAlpha20: rgba("#C7DAF6", 0.2),
  mythicAlpha40: rgba("#C7DAF6", 0.4),
  mythicAlpha80: rgba("#C7DAF6", 0.8),
  legendary: rgba("#8582E9", 1),
  legendaryAlpha10: rgba("#8582E9", 0.1),
  legendaryAlpha20: rgba("#8582E9", 0.2),
  legendaryAlpha40: rgba("#8582E9", 0.4),
  legendaryAlpha80: rgba("#8582E9", 0.8),
  rare: rgba("#D06AAE", 1),
  rareAlpha10: rgba("#D06AAE", 0.1),
  rareAlpha20: rgba("#D06AAE", 0.2),
  rareAlpha40: rgba("#D06AAE", 0.4),
  rareAlpha80: rgba("#D06AAE", 0.8),
  premium: rgba("#4AB4A7", 1),
  premiumAlpha10: rgba("#4AB4A7", 0.1),
  premiumAlpha20: rgba("#4AB4A7", 0.2),
  premiumAlpha40: rgba("#4AB4A7", 0.4),
  premiumAlpha80: rgba("#4AB4A7", 0.8),
  standard: rgba("#41A575", 1),
  standardAlpha10: rgba("#41A575", 0.1),
  standardAlpha20: rgba("#41A575", 0.2),
  standardAlpha40: rgba("#41A575", 0.4),
  standardAlpha80: rgba("#41A575", 0.8),
  alert: "#F95370",
  alertAlpha20: rgba("#F95370", 0.2),
  alertAlpha80: rgba("#F95370", 0.8),
  caution: "#f59e0b",
  heartRed: "#ff4444",
  error: "#ffa87d",
  errorAlpha05: rgba("#ffa87d", 0.05),
  errorAlpha10: rgba("#ffa87d", 0.1),
  errorAlpha50: rgba("#ffa87d", 0.5),
  darkerError: luminance("#ffa87d", -0.1),
  envy: "#4dbd94",
  envyAlpha05: rgba("#4dbd94", 0.05),
  envyAlpha10: rgba("#4dbd94", 0.1),
  envyAlpha20: rgba("#4dbd94", 0.2),
  envyAlpha30: rgba("#4dbd94", 0.3),
  envyAlpha40: rgba("#4dbd94", 0.4),
  envyAlpha50: rgba("#4dbd94", 0.5),
  envyAlpha80: rgba("#4dbd94", 0.8),
  envyAlpha90: rgba("#4dbd94", 0.9),
  darkerEnvy: luminance("#4dbd94", -0.2),
  champion: "#1278a1",
  championAlpha70: rgba("#1278a1", 0.7),
  championAlpha90: rgba("#1278a1", 0.9),
  darkerChampion: luminance("#1278a1", -0.1),
  royalty: "#72439a",
  specialBackgroundColor: "#034b8f",
  ned: "#1c2a34",
  nedAlpha50: rgba("#1c2a34", 0.5),
  nedLight: "#1f2d38",
  turbo: "#71AAFF",
  turboAlpha50: rgba("#71AAFF", 0.5),
  turboAlpha20: rgba("#71AAFF", 0.2),
  turboAlpha10: rgba("#71AAFF", 0.1),
  blue100: "#71AAFF",
  darkerNed: "#18252D",
  darkerNedAlpha20: rgba("#18252D", 0.2),
  darkerNedAlpha50: rgba("#18252D", 0.5),
  darkerNedAlpha80: rgba("#18252D", 0.8),
  flashSuccess: "#E8F8F1",
  flashWarning: "#FFF8F4",
  modalBg: "#10161a",
  grey825: "#14212a",
  gray: "#6a6a6a",
  gray825: "#14212a",
  gray850: "#141E26",
  grey850: "#141E26",
  white: "#FFFFFF",
  whiteAlpha90: rgba("#FFFFFF", 0.9),
  soHot: "#FF3000",
  goldStar: "#FFD700",
  lightGray: "#888888",
  lightestGray: "#aaaaaa",
  nearWhite: "#f8f8f8",
  shade100: "#F9FAFB",
  shade200: "#C7D4D7",
  shade300: "#8FA9AF",
  shade400: "#557077",

  // Creator Cards
  audio: "#75F0C3",
  intros: "#FF95C2",
  memes: "#E3D345",
  music: "#71AAFF",
  outros: "#AA95FE",
  overlays: "#45AA85",
  specialfx: "#F95370",
  thumbnails: "#63C1CD",
  transitions: "#FFA87D",

  enemyTeam: "#F95370",
  friendlyTeam: "#3980E9",

  // CS2 timeline
  ctSide: "#4da6ff",
  tSide: "#f0b232",
  bestMoment: "#ffd700",
  timelineDefault: "#8b8fa3",

  riotGames: "#D13639",
  riotRed: "#F12B15",
  riotRedAlpha20: rgba("#F12B15", 0.2),
  riotRedAlpha90: rgba("#F12B15", 0.9),
  steamBlue: "#1278a1",
  steamBlueBg: "#2f4656",
  steamBlueAlpha20: rgba("#1278a1", 0.2),
  steamBlueAlpha30: rgba("#1278a1", 0.3),
  epicGames: "#313131",
  steam: "#171a21",
  battleNet: "#148EFF",
  youtube: "#FF0000",
  twitch: "#6441a5",
  tiktok: "#000000",
  twitter: "#1DA1F2",
  instagram: "#E1306C",

  pinPurple: "#c180f6ff",
  pinPurpleAlpha60: rgba("#9231e1", 0.6),
  pinPurpleAlpha40: rgba("#9a58d1", 0.4),
  pinHoverBrown: "#8B5A2B",
  pinHoverBrownAlpha60: rgba("#8B5A2B", 0.6),
  pinHoverOrange: "#FFA500",
  pinHoverOrangeAlpha40: rgba("#FFA500", 0.4),

  errorOutline: "#ff4500",

  proPlayer: "#f86b85ff",

  premiumPurple: "#a855f7",
  premiumPurpleAlpha03: rgba("#a855f7", 0.03),
  premiumPurpleAlpha05: rgba("#a855f7", 0.05),
  premiumPurpleAlpha08: rgba("#a855f7", 0.08),
  premiumPurpleAlpha10: rgba("#a855f7", 0.1),
  premiumPurpleAlpha15: rgba("#a855f7", 0.15),
  premiumPurpleAlpha20: rgba("#a855f7", 0.2),
  premiumPurpleAlpha30: rgba("#a855f7", 0.3),
  premiumPurpleAlpha40: rgba("#a855f7", 0.4),
  premiumPurpleAlpha50: rgba("#a855f7", 0.5),
  premiumPurpleAlpha80: rgba("#a855f7", 0.8),

  timelineGold: "#e8a93e",
  timelineGoldAlpha20: rgba("#e8a93e", 0.2),
  timelineGoldAlpha40: rgba("#e8a93e", 0.4),

  // Subscription tier accent colors
  tierEssentials: "#4ebd94",
  tierEssentialsDark: "#3da87f",
  tierEssentialsAlpha15: rgba("#4ebd94", 0.15),
  tierEssentialsAlpha20: rgba("#4ebd94", 0.2),
  tierEssentialsAlpha25: rgba("#4ebd94", 0.25),
  tierEssentialsAlpha40: rgba("#4ebd94", 0.4),
  tierPro: "#00c8dc",
  tierProDark: "#00a8b8",
  tierProAlpha15: rgba("#00c8dc", 0.15),
  tierProAlpha20: rgba("#00c8dc", 0.2),
  tierProAlpha25: rgba("#00c8dc", 0.25),
  tierProAlpha40: rgba("#00c8dc", 0.4),
  tierPlat: "#9a58d1",
  tierPlatDark: "#7b46a8",
  tierPlatAlpha15: rgba("#9a58d1", 0.15),
  tierPlatAlpha20: rgba("#9a58d1", 0.2),
  tierPlatAlpha25: rgba("#9a58d1", 0.25),
  tierPlatAlpha40: rgba("#9a58d1", 0.4),
};

export { colors };
